import { JSONContent } from '@tiptap/core';
import { Size, TextPinComponent, Vector } from '../../models';
import { stringToProsemirror } from '../../tip-tap';
import { newBox, newSize } from '../geometry';
import { defaultOrder } from '../order';
import { randomId } from '../random-id';
import { initialPinComponentPosition } from './pin-component';

type NewTextPinComponentProps = {
  content?: JSONContent;
  position?: Vector;
  size?: Size;
  rotation?: number;
  settings?: Partial<TextPinComponent['settings']>;
  order?: string;
  id?: string;
  useDefaultTemplateStyles?: boolean;
};

export function newTextPinComponent({
  content = stringToProsemirror('Text'),
  position = initialPinComponentPosition,
  size = newSize(175, 175),
  rotation = 0,
  settings = {},
  order = defaultOrder,
  id,
}: NewTextPinComponentProps): TextPinComponent {
  return {
    type: 'TEXT',
    id: id || randomId(),
    settings: {
      tipTapContent: content,
      ...settings,
    },
    layout: newBox(position, size, rotation),
    order,
  };
}
